export default "__VITE_ASSET__CqnUTuxC__"